var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('canvas',{ref:"canvas",style:({ width: `${_vm.config.containerW}px`, height: `${_vm.config.containerH}px` }),attrs:{"id":"barCharts"}})
}
var staticRenderFns = []

export { render, staticRenderFns }